import React from "react";
import { css } from "react-emotion";
import * as styles from "../newStyles.styles";
import Footer from "../Footer";
import Header from "../Header";
import LoginSignup from "../Authentication/LoginSignup";
import { StyleSharp } from "@material-ui/icons";
import CalendyForm from "../MarketingLandingPage/CalendyForm";

const body = css`
  * {
    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }
  }
  height: 100%;
  margin: 0;
  padding-top: 0.1px;
`;
// classes
const wrapper = css`
  width: 100%;
  margin: 0 auto;
  float: none;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

function OurMission({ history }) {
  return (
    <div className={body}>
      <div className={wrapper}>
        <Header history={history} />
        <main
          style={{
            width: "100%",
            minHeight: "100vh",
            backgroundColor: "rgb(255, 255, 255)",
            flex: "1 0 auto",
            textAlign: "center",
          }}
        >
          <div
            className={styles.row}
            style={{ marginBottom: "0px", justifyContent: "center" }}
          >
            {" "}
            <styles.H2
              style={{
                textAlign: "center",
                marginBottom: "2rem",
                marginTop: "60px",
              }}
            >
              Our <span className={styles.styledUnderline}>Mission</span>
            </styles.H2>
          </div>
          <div
            className={styles.row}
            style={{
              marginBottom: "0px",
              padding: "30px 10px",
              backgroundImage: "linear-gradient(135deg,#89d2d3,#b1dada)",
            }}
          >
            <div className={styles.maxWidthWrapper}>
              <div className={styles.inner} style={{ paddingBottom: "4rem" }}>
                <styles.H3
                  style={{
                    fontWeight: "normal",
                    color: "white",
                    textAlign: "center",
                    letterSpacing: "-0.1rem",
                    margin: "0px",
                  }}
                >
                  We believe no business is too small to benefit from
                  technology.
                  <br />
                  <br />
                  Accessible and affordable e-commerce tools can fuel growth for
                  every business owner and create positive change in their
                  community.
                </styles.H3>
              </div>
            </div>
          </div>
          <div className={styles.row} style={{ marginBottom: "0px" }}>
            <div className={styles.maxWidthWrapper}>
              <div className={styles.inner} style={{ paddingBottom: "4rem" }}>
                <div className={styles.innerContainer60}>
                  <styles.P
                    style={{
                      lineHeight: "1.875",
                      fontWeight: "300",
                    }}
                  >
                    The Mobile360 founding team knows firsthand that a small
                    business can improve a family's livelihood. Some of us were
                    supported by small business owners growing up, others have
                    worked at small businesses, and a few have even successfully
                    built their own.
                    <br />
                    <br />
                    This experience alone was enough for us to begin the
                    Mobile360 journey, but in doing so we learned so much more
                    about the broader benefits of small business
                    entrepreneurship.
                    <br />
                    <br />
                    Millions of small businesses employ half the workforce in
                    the United States, and they disproportionately provide
                    employment to underserved populations in rural and
                    inner-city communities. Eye-opening research by JPMorgan
                    Chase concludes that a modest increase in the number of
                    employees hired by existing small businesses (1-3 employees)
                    could create enough employment opportunities for all
                    currently unemployed inner-city residents. We believe this
                    effect can be universal. This has become our touchstone.
                    <br />
                    <br />
                    At Mobile360 we are making it our mission to empower the
                    smallest business owners to not only support their families,
                    but also grow large enough to support new jobs in their
                    communities.
                  </styles.P>
                </div>
                <div className={styles.innerContainer40}>
                  <hr className={styles.innerDividerTop} />
                  <styles.P
                    style={{
                      lineHeight: "1.875",
                      marginTop: "1.625rem",
                      marginBottom: "1.625rem",
                      fontSize: "1.75em",
                      lineHeight: "1.75",
                      fontWeight: "300",
                      letterSpacing: "-0.025rem",
                      color: "rgba(36,36,36,0.588)",
                    }}
                  >
                    A modest increase in the number of employees hired by
                    existing small businesses could create enough employment
                    opportunities for all currently unemployed.
                  </styles.P>
                  <hr className={styles.innerDividerBottom} />
                </div>
              </div>
            </div>
          </div>
          <div
            className={styles.row}
            style={{ marginBottom: "0px", justifyContent: "center" }}
          >
            {" "}
            <styles.H2
              style={{
                textAlign: "center",
                marginBottom: "2rem",
                marginTop: "0px",
              }}
            >
              Why mobile e-commerce for{" "}
              <span className={styles.styledUnderline}>small</span> businesses?
            </styles.H2>
          </div>
          <div className={styles.row} style={{ marginBottom: "0px" }}>
            <div className={styles.maxWidthWrapper}>
              <div className={styles.inner} style={{ paddingBottom: "4rem" }}>
                <div className={styles.innerContainerLeft40}>
                  <hr className={styles.innerDividerTop} />
                  <div className={styles.innerListContainer}>
                    <ul className={styles.innerList}>
                      <li className={styles.innerListItem}>
                        <p className={styles.innerListParagraph}>
                          92% of consumers prefer to buy from a small business
                          if it's convenient.
                        </p>
                      </li>
                      <li className={styles.innerListItem}>
                        <p className={styles.innerListParagraph}>
                          85% of Americans own a smartphone.
                        </p>
                      </li>
                      <li className={styles.innerListItem}>
                        <p className={styles.innerListParagraph}>
                          50% of e-commerce transactions occur on a mobile
                          device.
                        </p>
                      </li>
                    </ul>
                  </div>
                  <hr className={styles.innerDividerBottom} />
                </div>
                <div className={styles.innerContainer60}>
                  <styles.P
                    style={{
                      lineHeight: "1.875",
                      fontWeight: "300",
                    }}
                  >
                    Nearly 1/3 of small businesses still do not own a website.
                    Many of the smallest businesses are leaning on social media
                    instead and believe that they are too small to require a
                    dedicated web presence. Other top reasons small business
                    owners opt-out of a dedicated web presence for their
                    businesses include a lack of budget, time, or technical
                    expertise.
                    <br />
                    <br />
                    These business owners are missing the opportunity to own the
                    relationship with their customers to drive repeat business,
                    and they are limiting their ability to find new customers.
                    The fact is that consumers *want* to buy from small
                    businesses, and they want to do it online, and increasingly
                    they want to do it on their mobile phones.
                    <br />
                    <br />
                    Mobile360 is built to close these gaps. Our Mobile360
                    Builder is designed to close the technological gap for the
                    smallest businesses to support mobile e-commerce, and the
                    Mobile360 Marketplace targets the discovery gap between
                    these businesses and the consumers that want to buy from
                    them.
                    <br />
                    <br />
                    Accessible technology will grow repeat sales and new
                    customers for small businesses. That growth will drive
                    change in our communities.
                  </styles.P>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.row}>
            {/************************************************************************************************
             *************************************************************************************************
             * Schedule a Demo Row
             * This row is for Calendy Demo scheduling
             *************************************************************************************************
             ************************************************************************************************/}
            <div className={styles.maxWidthWrapper}>
              <div className={styles.col + " " + styles.col1}>
                <styles.H2
                  style={{
                    textAlign: "center",
                    width: "100%",
                    marginBottom: "30px",
                  }}
                >
                  Schedule a Free 30 Minute{" "}
                  <span className={styles.styledUnderline}>Demo</span>
                </styles.H2>

                <br></br>
                <CalendyForm />
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default OurMission;
